import { PersonAgeStatus } from "../generated/api-client";

export const personAgeStatusValues: PersonAgeStatus[] = [
    "Baby",
    "PED1",
    "PED2",
    "ED1",
    "ED2",
    "ED3",
    "ED4",
    "ER1",
    "ER2",
    "ER3",
    "AC",
    "Youth",
    "Adult",
    "Senior",
];

export const personAgeStatusLabels: Record<PersonAgeStatus, string> = {
    Baby: "Bebé",
    PED1: "Pre-escuela 1",
    PED2: "Pre-escuela 2",
    ED1: "Escuela Dominical 1",
    ED2: "Escuela Dominical 2",
    ED3: "Escuela Dominical 3",
    ED4: "Escuela Dominical 4",
    ER1: "Escuela de Religión 1",
    ER2: "Escuela de Religión 2",
    ER3: "Escuela de Religión 3",
    AC: "Año de Confirmación",
    Youth: "Juventud",
    Adult: "Adulto/a",
    Senior: "3ra Edad",
};

export const personAgeStatusOptions = personAgeStatusValues.map(value => ({
    value,
    label: personAgeStatusLabels[value],
}));
